import { useEffect, useState } from "react";
import { CalendarPlus, MapPin, Phone, ShieldCheck } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const DETAIL_ROWS = [
  ["schedule", "Schedule"],
  ["end_date", "End date"],
  ["pay_rate", "Pay rate"],
  ["supervisor_name", "Supervisor"],
  ["clock_in_instructions", "How to clock in"],
  ["arrival_instructions", "Arrival & check-in"],
  ["required_documents", "Required documents"],
  ["notes", "Additional notes"],
];

function formatDate(value) {
  const date = new Date(`${value}T00:00:00`);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric", year: "numeric" });
}

async function downloadIcs(assignmentId) {
  const response = await api.get(`/assignments/${assignmentId}/confirmation.ics`, { responseType: "blob" });
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = "tagforce-first-day.ics";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export const ProviderConfirmationsPanel = () => {
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get("/assignments/my-confirmations")
      .then((response) => setItems(response.data))
      .catch((requestError) => setError(formatApiError(requestError)));
  }, []);

  if (error) return <p className="form-message error-message" data-testid="provider-confirmations-error">{error}</p>;
  if (!items || !items.length) return null;
  return (
    <section className="provider-queue-panel provider-confirmations-panel" data-testid="provider-confirmations-panel">
      <div className="provider-queue-heading">
        <ShieldCheck size={18} />
        <div>
          <h2>Assignment confirmations</h2>
          <p>{items.length} confirmed assignment{items.length === 1 ? "" : "s"} · everything you need for day one</p>
        </div>
      </div>
      {items.map((item) => {
        const c = item.confirmation;
        return (
          <article className="provider-confirmation-card" data-testid={`provider-confirmation-${item.id}`} key={item.id}>
            <header>
              <div>
                <strong>{item.role_name}</strong>
                <span>{item.client_name}</span>
              </div>
              <em data-testid={`provider-confirmation-start-${item.id}`}>Starts {formatDate(c.start_date)}</em>
            </header>
            {c.location && (
              <p className="provider-confirmation-location"><MapPin size={14} /> {c.location}</p>
            )}
            {(c.site_contact_name || c.site_contact_phone || c.site_contact_email) && (
              <p className="provider-confirmation-contact">
                <Phone size={14} /> {[c.site_contact_name, c.site_contact_phone, c.site_contact_email].filter(Boolean).join(" · ")}
              </p>
            )}
            <dl className="provider-confirmation-details">
              {DETAIL_ROWS.filter(([key]) => c[key]).map(([key, label]) => (
                <div key={key}>
                  <dt>{label}</dt>
                  <dd>{c[key]}</dd>
                </div>
              ))}
            </dl>
            <footer>
              <small>Sent {new Date(c.sent_at).toLocaleDateString()} by {c.sent_by_name}</small>
              <button className="button button-secondary" data-testid={`download-ics-${item.id}`} type="button" onClick={() => downloadIcs(item.id)}>
                <CalendarPlus size={14} /> Add first day to calendar
              </button>
            </footer>
          </article>
        );
      })}
    </section>
  );
};
